import React from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

export const CashOutSubmittingComponent = observer(
	function CashOutSubmittingComponent() {
		const { t } = useTranslation();

		return (
			<div className="popup__footer popup__footer--bordered">
				<button
					disabled
					className="popup__btn popup__btn--secondary btn btn--med btn--primary--inverted btn--icon u-color--sent--danger"
				>
					<i className="u-icon u-icon--sml u-icon--remove u-color--sent--danger" />
					<span>{t<string>("COMMON.CANCEL")}</span>
				</button>
				<button
					disabled
					className="popup__btn popup__btn--primary btn btn--med btn--success btn--icon"
				>
					<i className="u-icon u-icon--sml u-icon--refresh u-color--core--snow"></i>
				</button>
			</div>
		);
	}
);
